import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Mail, MapPin, Phone, Instagram } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/contact", form);
      toast.success("Message received. We'll respond within 24 hours.");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="contact-page" className="max-w-6xl mx-auto px-6 py-20 grid lg:grid-cols-2 gap-16">
      <div>
        <p className="small-label">Get in touch</p>
        <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl mt-3 leading-tight">Hello, beautiful.</h1>
        <p className="text-stone mt-4 max-w-md">
          Need styling advice, shade matching or order help? Our wig concierge responds within 24 hours.
        </p>
        <div className="mt-8 space-y-4 text-sm">
          <p className="flex items-center gap-3"><MapPin strokeWidth={1.5} className="w-4 h-4 text-gold" /> Sandton, Johannesburg, ZA</p>
          <p className="flex items-center gap-3"><Phone strokeWidth={1.5} className="w-4 h-4 text-gold" /> +27 11 555 0123</p>
          <p className="flex items-center gap-3"><Mail strokeWidth={1.5} className="w-4 h-4 text-gold" /> hello@maisonluxe.co.za</p>
          <p className="flex items-center gap-3"><Instagram strokeWidth={1.5} className="w-4 h-4 text-gold" /> @maisonluxe.za</p>
        </div>
        <p className="small-label mt-8">Mon–Sat · 09:00–18:00 SAST</p>
      </div>

      <form onSubmit={submit} className="space-y-3">
        <input required placeholder="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="contact-name" className="w-full bg-ivory border border-stone-line rounded-2xl px-4 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-charcoal" />
        <input required type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="contact-email" className="w-full bg-ivory border border-stone-line rounded-2xl px-4 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-charcoal" />
        <input required placeholder="Subject" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} data-testid="contact-subject" className="w-full bg-ivory border border-stone-line rounded-2xl px-4 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-charcoal" />
        <textarea required rows={6} placeholder="How can we help?" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="contact-message" className="w-full bg-ivory border border-stone-line rounded-2xl px-4 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-charcoal" />
        <button disabled={busy} data-testid="contact-submit" className="btn-primary w-full">{busy ? "Sending…" : "Send message"}</button>
      </form>
    </div>
  );
}
